import { ErrorBoundary } from 'react-error-boundary'

import { Settings } from '../features/selfservice/settings/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const BuyerSettingsPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <Settings />
    </ErrorBoundary>
  )
}
